export default "__VITE_ASSET__9ZPR1I4h__"